import Native from "./Native";
import { encode } from "js-base64";
import { isArray, isTruely } from "./is";
/**
 * 复制到剪切板
 * @param value 值
 */
export function copy(value: string): boolean {
  const text = document.createElement("textarea");
  let result = true;
  try {
    text.value = value;
    document.body.appendChild(text);
    text.select();
    document.execCommand("copy");
  } catch (error) {
    result = false;
  }
  document.body.removeChild(text);
  return result;
}

/**
 * 在js中使用px时调用此函数将设计稿px转换为当前rem适用的px
 * @param px px
 */
export function toRem(px: number) {
  const key = Math.round(window.innerWidth * 0.1333333333333333);
  return (px / 100) * key;
}

export function pxToRem(px: number) {
  const key = Math.round(window.innerWidth * 0.1333333333333333);
  return px / key;
}

/**
 * 转换的px
 * @param size rem大小
 */
export function remToPx(size: string) {
  if (size.includes("rem")) {
    return (
      Number(size.split("rem")[0]) *
      Math.round(window.innerWidth * 0.1333333333333333)
    );
  }
  return Number(size.split("px")[0]);
}

/**
 * style属性的px转换成number
 * @param px dom style属性
 */
function stylePxToNumber(px: string) {
  if (px.includes("px")) {
    px = px.split("px")[0];
  }
  return Number(px);
}

/** 是否在微信内打开 */
export function isOpenInWechat() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes("micromessenger")) {
    return true;
  } else {
    return false;
  }
}

/**
 * 处理url 去掉微信返回时带的参数
 */
export function handleWXbackUrl(ifencode = true) {
  const w = location.href.indexOf("?");
  const j = location.href.indexOf("#");
  let href = window.location.href;
  let url;
  if (w !== -1 && j > w) {
    href =
      location.href.substr(0, w) +
      location.href.substr(j, location.href.length);
    url = href;
  } else {
    url = location.href;
  }
  return ifencode ? encodeURIComponent(url) : url;
}
/**
 * 获取url参数
 */
export function getUrlParam(name: string) {
  const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  const r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

/**
 * 验证规则
 */
const rules = [
  null,
  // 其他 - 非空
  (value: string) => !!value,
  // 手机
  (value: string) => new RegExp(/^[1][0-9][0-9]{9}$/).test(value),
  // 普通文本 - 非空
  (value: string) => !!value,
  // 身份证 - 二代身份证
  (value: string) =>
    new RegExp(
      /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/
    ).test(value),
  // 邮箱
  (value: string) =>
    new RegExp(
      /^[A-Za-zd]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/
    ).test(value),
  // 纯数字
  (value: string) => new RegExp(/^[0-9]*$/).test(value)
];
/**
 * 验证输入是否合法
 * @param value 验证值
 * @param type 验证类型 {1:其他,2:手机,3:普通文本,4:身份证,5:邮箱,6:数字}
 */
export function verifier(value: string, type: number) {
  if (!value) return false;
  if (!type) return true;
  return rules[type]!(value);
}

/**
 * 跳转网页
 * @param url 地址
 */
export function openUrl(url: string) {
  if (window.ZWY_CLOUD && Native.isOpenInApp()) {
    Native.openWebBrowser({
      id: "",
      sourceId: "",
      detailViewType: "98",
      sourceType: "0",
      commentType: "0",
      contextType: "",
      isShowTop: "1",
      isShowBottom: "0",
      isShowMore: "0",
      url: url,
      shareUrl: url,
      title: encode(document.title),
      synopsis: "",
      shareImgUrl: ""
    });
  } else {
    window.open(url);
  }
}

/**
 * 获取运行环境
 */
export function getSystemName() {
  let os;
  if (window.ZWY_CLOUD.isOpenInApp()) {
    os = "APP";
  } else {
    const wx = navigator.userAgent.toLowerCase();
    if (wx.indexOf("micromessenger") !== -1) {
      os = "WX";
    } else {
      // 需要新增pc类型
      os = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)
        ? "H5"
        : "PC";
    }
  }
  return os;
}
/** 根据UA获取AppId */
export function getAppIdFromUA() {
  const ua = navigator.userAgent;
  const matchArr = /CQ_XHL\((.+)\)/.exec(ua);
  if (matchArr && matchArr.length) {
    const appinfoArr = matchArr[1].split(";");
    if (appinfoArr.length) {
      return appinfoArr[2];
    } else {
      return "";
    }
  } else {
    return "";
  }
}

/**
 * 缩放Dom的大小
 * @param scale 比例
 */
export function zoomDom(scale: number, dom: HTMLElement) {
  function execute(el: HTMLElement) {
    for (const e of el.children) {
      const temp = e as HTMLElement;
      temp.style.width &&
        (temp.style.width =
          pxToRem(stylePxToNumber(temp.style.width) * scale) + "rem");
      temp.style.height &&
        (temp.style.height =
          pxToRem(stylePxToNumber(temp.style.height) * scale) + "rem");
      temp.style.fontSize &&
        (temp.style.fontSize =
          pxToRem(stylePxToNumber(temp.style.fontSize) * scale) + "rem");
      temp.style.padding &&
        (temp.style.padding = temp.style.padding
          .split(" ")
          .map(item => pxToRem(stylePxToNumber(item) * scale) + "rem")
          .join(" "));
      temp.style.margin &&
        (temp.style.margin = temp.style.margin
          .split(" ")
          .map(item => pxToRem(stylePxToNumber(item) * scale) + "rem")
          .join(" "));
      if (temp.children) {
        execute(temp);
      }
    }
  }
  if (dom.children.length) {
    execute(dom);
  }
}

export function throttle(func: Function, wait: number) {
  let ctx: any,
    args: any[] | null = null,
    timerId: number,
    last = 0,
    returnVal: any;

  function call() {
    timerId = 0;
    last = +new Date();
    returnVal = func.apply(ctx, args);
    ctx = null;
    args = null;
  }

  return function throttled(this: any, ..._args: any[]) {
    ctx = this;
    args = _args;
    const delta = Date.now() - last;
    if (!timerId)
      if (delta >= wait) call();
      else timerId = setTimeout(call, wait - delta);
    return returnVal;
  };
}

export function generator<T = unknown>({
  value,
  delay
}: {
  value: unknown[];
  delay: number;
}): { asyncIterator: AsyncIterable<T> };
export function generator<T = unknown>({
  value,
  times,
  delay
}: {
  value: unknown;
  times: number;
  delay: number;
}): { asyncIterator: AsyncIterable<T> };
export function generator<T = unknown>({
  value,
  times,
  delay = 1000
}: {
  value: unknown;
  times?: number;
  delay: number;
}): { asyncIterator: AsyncIterable<T> } {
  const asyncIterator = {
    [Symbol.asyncIterator]() {
      return {
        n: 0,
        async next() {
          this.n += 1;
          return new Promise<{ done: boolean; value: any }>(resolve => {
            setTimeout(
              () =>
                resolve({
                  value: isArray(value) ? value[this.n] : value,
                  done:
                    this.n >
                    (!isTruely(times)
                      ? isArray(value)
                        ? value.length
                        : Number.MAX_SAFE_INTEGER
                      : times)
                }),
              delay
            );
          });
        }
      };
    }
  };
  return { asyncIterator };
}
export function getminute(unit = 1) {
  function repair(i: any) {
    if (i >= 0 && i <= 9) {
      return "0" + i;
    } else {
      return i;
    }
  }
  const date = new Date(); //当前时间
  const year = date.getFullYear(); //返回指定日期的年份
  const month = repair(date.getMonth() + 1); //月
  const day = repair(date.getDate()); //日
  const hour = repair(date.getHours()); //时
  const minute = repair(date.getMinutes()); //分
  if (unit == 1) {
    const tt = `${year}/${month}/${day} ${hour}:${minute}:00`;
    return new Date(tt).getTime();
  } else {
    const list = [0];
    for (let i = 0; i < 60 / unit; i++) {
      const newunit = unit * (i + 1);
      if (newunit < 60) {
        list.push(newunit);
      }
    }
    const tt = `${year}/${month}/${day} ${hour}:${
      list[Math.floor(minute / unit)]
    }:00`;
    return new Date(tt).getTime();
  }
}
